import React from 'react';
import { string, object } from 'prop-types';
import s from '../overviewWidget.module.css';
import sButton from '../../../../components/MLButton/MLButton.module.css';

const PathFinderDiagnosticsWidget = ({ title, description, diagnosticsUrl, btnText }) => (
  <div className={[s.OverviewCard, s.OverviewCardPF].join(' ')}>
    <div>
      <h3>{title}</h3>
      <p>{description}</p>
      <a
        href={diagnosticsUrl}
        el="noopener noreferrer"
        className={[s.viewLink, sButton.btnSecondary].join(' ')}
      >
        {btnText}
      </a>
    </div>
  </div>
);

PathFinderDiagnosticsWidget.defaultProps = {
  title: 'Pre-course Diagnostic Assessment',
  description: 'Do my students have the pre-requisite knowledge and skills for this course?',
  btnText: 'View Diagnostic Report',
  diagnosticsUrl: '',
};
PathFinderDiagnosticsWidget.propTypes = {
  title: string,
  description: string,
  btnText: string,
  diagnosticsUrl: object,
};

export default PathFinderDiagnosticsWidget;
